import Linegraph from "@/features/shared/widgets/graphs/linegraph";
import Histogram from "@/features/shared/widgets/graphs/histogram";
import Scatterplot from "@/features/shared/widgets/graphs/scatterplot";
import { GraphProps } from "@/features/shared/widgets/graphs/graph.types";
import useRefreshWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { usePrimaryUnit } from "@/features/shared/widgets/graphs/hooks/usePrimaryUnit";

const HISTOGRAM_PARAMETERS = ["nc", "nc1", "nc2", "nc3"];

const SCATTERPLOT_PARAMETERS = ["dd", "hc", "hc1", "hc2", "hc3"];

const Graph = (props: GraphProps) => {
  const { id, configuration, data } = props;
  useRefreshWidget(id);

  const primaryUnit = usePrimaryUnit(data);

  if (
    configuration.lines.some((line) => HISTOGRAM_PARAMETERS.includes(line.edr_parameter)) ||
    primaryUnit?.symbol === "okta"
  ) {
    return <Histogram {...props} />;
  }

  if (
    configuration.lines.some((line) =>
      SCATTERPLOT_PARAMETERS.includes(line.edr_parameter),
    ) ||
    primaryUnit?.symbol === "degree" ||
    primaryUnit?.type === "foot"
  ) {
    return <Scatterplot {...props} />;
  }

  return <Linegraph {...props} />;
};

export default Graph;
